module.exports = __webpack_public_path__ + "static/media/rotate_device_fff_bg.34cca163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotate_device_fff_bg.png
// module id = 187
// module chunks = 0